export const prompts = [
    "What inspired you to start or work in your current business?",
    "What’s the most important lesson you’ve learned from a business failure?",
    "What does success look like for your business in five years?",
    "What’s one skill you believe is essential for any business owner to master?",
    "How do you handle criticism or feedback about your business?",
    "What’s a recent decision in your business that you’re especially proud of?",
    "What’s the biggest challenge you’ve faced in your business journey, and how did you overcome it?",
    "What is one area of your business where you feel you need to grow or improve?",
    "How do you measure the impact of your business beyond revenue?",
    "What’s the best piece of business advice you’ve ever received?",
    "If you could collaborate with any business or entrepreneur, who would it be and why?",
    "What’s one thing you do to stay creative and inspired in your business?",
    "How do you prioritize tasks when everything feels urgent?",
    "What’s the most impactful investment you’ve made in your business?",
    "What’s a business trend or tool you’re excited to explore?",
    "How do you ensure your business aligns with your personal values?",
    "What’s your favorite way to celebrate business milestones?",
    "If you could delegate one task in your business, what would it be and why?",
    "What’s one piece of advice you’d give to someone starting a business in your field?",
    "What legacy do you want your business to leave behind?",
    "What’s the most fulfilling part of running your business right now?",
    "How do you define success for your business at this stage?",
    "What’s one thing you wish more people understood about being a solopreneur?",
    "How do you balance ambition with the need for rest in your business?",
    "What’s a recent win in your business that you’re especially proud of?",
    "How do you decide which opportunities to pursue and which to decline?",
    "What’s the biggest mindset shift you’ve had since starting your business?",
    "How do you handle moments of self-doubt in your business journey?",
    "What motivates you to keep going on the hard days?",
    "How do you manage the feeling of wearing too many hats in your business?",
    "What’s one area of your business you’d like to improve or simplify?",
    "How do you stay connected to your ‘why’ when things feel overwhelming?",
    "What’s a belief about business success you’ve outgrown recently?",
    "How do you celebrate small wins in your business?",
    "What’s one challenge you’re currently navigating in your business?",
    "How do you maintain focus on your long-term vision while handling daily tasks?",
    "What’s one way your business has positively impacted your personal life?",
    "What’s a fear you’ve faced as a business owner, and how did you overcome it?",
    "How do you balance personal growth with business growth?",
    "What’s one piece of advice you’d give to someone just starting out?",
    "How do you ensure your business stays aligned with your personal values?",
    "What’s the most rewarding relationship you’ve built through your business?",
    "How do you stay motivated when you hit a plateau in your business?",
    "What’s one decision you’ve made that has had a big impact on your business growth?",
    "How do you approach setting boundaries between work and personal life?",
    "What’s one way you’ve surprised yourself as a business owner?",
    "How do you manage the pressure of being both the visionary and the executor?",
    "What’s one mindset block you’ve worked to overcome recently?",
    "How do you measure progress in your business beyond revenue?",
    "What’s one system or habit that keeps your business running smoothly?",
    "How do you decide when to delegate or outsource tasks in your business?",
    "What’s one way you cultivate creativity in your business?",
    "How do you handle imposter syndrome as a business owner?",
    "What’s one aspect of running a business that brings you the most joy?",
    "How do you stay connected with your audience or clients on a personal level?",
    "What’s a boundary you’ve set in your business that has made a difference?",
    "How do you handle uncertainty or risk in your business decisions?",
    "What’s a skill you’ve developed through running your business that you’re proud of?",
    "How do you navigate feelings of comparison with other business owners?",
    "What’s one ambitious goal you’re working toward right now?",
    "How do you balance client work with growing your business?",
    "What’s one challenge you didn’t expect to face as a business owner?",
    "How do you keep your vision clear when facing daily distractions?",
    "What’s one lesson you’ve learned about resilience through your business?",
    "How do you decide where to invest in your business?",
    "What’s one thing you’ve done to make your business more sustainable?",
    "How do you manage overwhelm when juggling multiple responsibilities?",
    "What’s a recent decision that has brought more ease into your business?",
    "How do you cultivate a growth mindset as a business owner?",
    "What’s one way you’ve grown as a leader in your business?",
    "How do you maintain confidence in your decisions when there’s no roadmap?",
    "What’s one way you keep your business aligned with your personal goals?",
    "How do you approach building relationships with your clients or customers?",
    "What’s one mindset practice that helps you navigate challenges in your business?",
    "How do you stay energized and inspired while running your business?",
    "What’s one way your business helps you make a positive impact?",
    "How do you prioritize what matters most in your business?",
    "What’s one thing you’re currently learning that supports your business growth?",
    "How do you approach competition in your industry?",
    "What’s a moment in your business that reminded you why you started?",
    "How do you decide when it’s time to pivot or try something new?",
    "What’s one way you take care of your mental health as a business owner?",
    "How do you approach goal-setting for your business?",
    "What’s one strategy you’ve implemented to grow your business recently?",
    "How do you handle negative feedback or criticism about your business?",
    "What’s one thing you do to stay connected with your team or collaborators?",
    "How do you ensure your business reflects your unique strengths?",
    "What’s one challenge that has helped you grow as a business owner?",
    "How do you stay grounded during busy or stressful periods?",
    "What’s one lesson about ambition that you’ve learned from your business?",
    "How do you decide which ideas to pursue and which to put aside?",
    "What’s one way you’ve improved your workflow or productivity recently?",
    "How do you maintain balance between financial goals and personal fulfillment?",
    "What’s one belief about success that keeps you motivated?",
    "How do you cultivate trust with your clients or audience?",
    "What’s one way your business has made you more resilient?",
    "How do you navigate feelings of isolation as an entrepreneur?",
    "What’s one way you’re currently stepping outside your comfort zone?",
    "How do you approach problem-solving in your business?",
    "What’s one thing you’ve let go of that wasn’t serving your business?",
    "How do you ensure your business evolves with your personal growth?",
    "What’s one area of your business you’re most excited about right now?",
    "How do you stay adaptable in a changing business landscape?",
    "What’s one way your business challenges you to grow?",
    "How do you decide what success looks like in each season of your business?",
    "What’s one way you manage stress or burnout as a business owner?",
    "How do you ensure your business continues to feel meaningful to you?",
    "What’s one way you invest in your personal growth to support your business?",
    "How do you manage uncertainty about the future of your business?",
    "What’s one way you create opportunities for connection in your business?",
    "How do you balance being both strategic and creative in your business?",
    "What’s one lesson you’ve learned about leadership in your business?",
    "How do you ensure your business continues to feel fun and inspiring?",
    "What’s one belief about your business you’ve never questioned but could reconsider?",
    "How would your business change if you operated as though failure wasn’t an option?",
    "What’s a limiting belief about your abilities that might be holding your business back?",
    "How would you approach your business differently if money weren’t a factor?",
    "What’s one assumption you’re making about your customers that could be wrong?",
    "If you could start your business over today, what would you do differently?",
    "What’s one belief about success that might be creating unnecessary pressure?",
    "How do you think your competitors view your business, and does it matter?",
    "What’s a current challenge you’re facing that could actually be an opportunity in disguise?",
    "What’s one thing you’ve been resisting in your business, and why?",
    "If you were your own client, what advice would you give yourself right now?",
    "What’s a decision you’ve been delaying that could unlock growth for your business?",
    "How would your business evolve if you prioritized your values above all else?",
    "What’s a fear you have about growth, and how might it be affecting your decisions?",
    "If you removed all constraints, what’s one bold move you’d make in your business today?",
    "What’s one way you could challenge the norms of your industry?",
    "How would your business look if you focused solely on impact rather than income?",
    "What’s a rule you’ve set for yourself in business that might no longer serve you?",
    "What’s one way your business model could be simplified without losing value?",
    "What’s something your audience or clients might want that you haven’t considered offering?",
    "How would you approach your business if you had to scale back to the essentials?",
    "What’s one thing you’re currently doing that feels misaligned with your goals?",
    "What’s a belief about your audience that might be limiting your growth?",
    "What’s a problem you’ve been avoiding addressing, and why?",
    "How would your business change if you completely trusted your instincts?",
    "What’s one thing you could outsource or automate to free up your time for creativity?",
    "What’s a strength of your business that you might be underestimating?",
    "What’s one belief about your niche or industry that you could challenge?",
    "If you had to double your prices tomorrow, how would you justify it to your customers?",
    "What’s a blind spot in your business that someone else has pointed out to you?",
    "How would your business strategy change if you aimed for long-term impact over short-term wins?",
    "What’s one belief about marketing or selling that you could reframe positively?",
    "What’s an unconventional idea you’ve had but haven’t acted on, and why?",
    "How would your business change if you focused more on collaboration than competition?",
    "What’s one belief about work-life balance that might not be serving you?",
    "How would your business look if you prioritized ease and joy over hustle?",
    "What’s a belief about yourself as a business owner that you’d like to challenge?",
    "How might stepping into a completely different role in your business shift your perspective?",
    "If you could ask one challenging question to your audience or clients, what would it be?",
    "What's your superpower as a business owner?",
    "What are your weakness in your business?",
];
